import React from 'react';

const Politics = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.2317 1.08671C10.0827 1.02709 9.91642 1.02709 9.76738 1.08671L1.43204 4.42084C1.19469 4.51578 1.03906 4.74565 1.03906 5.00128V6.66835C1.03906 7.01361 1.31895 7.2935 1.66421 7.2935H18.3349C18.6802 7.2935 18.9601 7.01361 18.9601 6.66835V5.00128C18.9601 4.74565 18.8044 4.51578 18.5671 4.42084L10.2317 1.08671ZM2.28936 6.0432V5.42453L9.99956 2.34045L17.7098 5.42453V6.0432H2.28936ZM2.28936 16.6708C2.28936 16.0954 2.75585 15.6289 3.33128 15.6289H16.6678C17.2433 15.6289 17.7098 16.0954 17.7098 16.6708V17.296H2.28936V16.6708ZM3.33128 14.3786C2.06532 14.3786 1.03906 15.4049 1.03906 16.6708V17.9211C1.03906 18.2664 1.31895 18.5463 1.66421 18.5463H18.3349C18.6802 18.5463 18.9601 18.2664 18.9601 17.9211V16.6708C18.9601 15.4049 17.9338 14.3786 16.6678 14.3786H15.6279V8.75211H14.3776V14.3786H12.2928V8.75211H11.0425V14.3786H8.95962V8.75211H7.70932V14.3786H5.62449V8.75211H4.37419V14.3786H3.33128Z",
      fill: "white"
    }
  )
);

export { Politics };
//# sourceMappingURL=Politics.js.map
